// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3TkHk","title":"Info_title__3Gb_T","links":"Info_links__2BZon","link":"Info_link__1W6jY","logo":"Info_logo__jXyGB"};